import __request__ from "routing/request";
export function get() {
  return __request__("GET", "/telemetry", null, {}, {
    "Accept": ["application/json"]
  });
}
export function getTelemetryUserSettings() {
  return __request__("GET", "/telemetry/user/settings", null, {}, {
    "Accept": ["application/json"]
  });
}
export function saveTelemetryUserSettings(JSONbody) {
  return __request__("PUT", "/telemetry/user/settings", JSONbody, {}, {
    "Accept": ["application/json"]
  });
}
